import { ApiServiceV1 } from '@services/api.service';

export default {
  async getProducts({
    suffix, state = null, name = null,
    pageNum = 1, pageSize = 10,
  }) {
    const { data } = await ApiServiceV1.get(`${suffix}/product`, {
      params: {
        state, name, pageNum, pageSize,
      },
    });
    return data || {};
  },
  createProduct({ suffix, data }) {
    return ApiServiceV1.post(`${suffix}/product`, data);
  },
  updateProduct({ suffix, name, data }) {
    return ApiServiceV1.post(`${suffix}/product/${encodeURIComponent(name)}`, data);
  },
};
